import { requestTool } from "../tools";

const CONTROLLER_URL = "/api/StartupConfiguration/";

const getStartupConfiguration = (url) => requestTool.getRequest(url + CONTROLLER_URL);

export const startupConfigurationService = { getStartupConfiguration };

export default startupConfigurationService;

